import React from 'react';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useQuery } from '@tanstack/react-query';
import { Container, Grid, Card, Button, Input, Segment, Header, Icon, Label } from 'semantic-ui-react';
import { posts } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

function Posts() {
  const { user } = useAuth();
  const [search, setSearch] = useState('');
  
  const { data: postsList, isLoading } = useQuery({
    queryKey: ['posts', search],
    queryFn: () => posts.list({ search }),
  });

  return (
    <>
      <Helmet>
        <title>Soapee - Posts</title>
      </Helmet>

      <Container>
        <Segment vertical>
          <Grid>
            <Grid.Row>
              <Grid.Column width={16}>
                <Header as="h1">Posts</Header>
                <Input
                  icon="search"
                  placeholder="Search posts..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  fluid
                />
              </Grid.Column>
            </Grid.Row>

            {user && (
              <Grid.Row>
                <Grid.Column width={16}>
                  <Button primary>
                    <Icon name="plus" /> Create Post
                  </Button>
                </Grid.Column>
              </Grid.Row>
            )}

            <Grid.Row>
              <Grid.Column width={16}>
                {isLoading ? (
                  <Segment loading />
                ) : (
                  <Card.Group>
                    {postsList?.data?.map((post) => (
                      <Card key={post.id}>
                        <Card.Content>
                          <Card.Header>{post.title}</Card.Header>
                          <Card.Meta>
                            Posted by {post.author?.name || 'Anonymous'}
                          </Card.Meta>
                          <Card.Description>
                            {post.content}
                          </Card.Description>
                          <Card.Meta>
                            <Label>
                              <Icon name="comment" /> {post.comment_count} comments
                            </Label>
                            <Label>
                              <Icon name="like" /> {post.like_count} likes
                            </Label>
                          </Card.Meta>
                        </Card.Content>
                        <Card.Content extra>
                          <Button fluid basic>
                            View Post
                          </Button>
                        </Card.Content>
                      </Card>
                    ))}
                  </Card.Group>
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </Container>
    </>
  );
}

export default Posts; 